/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Dropdown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#525865' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: '0 0 24 24' },
        React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: strokeWidth, fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { id: "Table/Action-Cell", transform: "translate(-359.000000, -25.000000)", fill: color, stroke: color },
                React.createElement("g", { id: "Group", transform: "translate(360.000000, 25.000000)" },
                    React.createElement("path", { d: "M0.885437786,0.552 L13.581129,0.552 C13.9414015,0.55251281 14.2337967,0.782251825 14.2331451,1.06532311 C14.2331451,1.15865458 14.2005106,1.24993482 14.1391598,1.32993322 L7.79066157,9.57028193 C7.60399862,9.8123284 7.20260801,9.89027556 6.89454888,9.74361182 C6.80448074,9.70053575 6.7287713,9.64104976 6.67394721,9.57028193 L0.327406942,1.32993322 C0.140743993,1.08737395 0.239949476,0.772508429 0.548661277,0.625844683 C0.650477431,0.577640515 0.766652273,0.552 0.885437786,0.552 Z", id: "Path" }))))));
};
export default Dropdown;
